import React from 'react'
import styled from 'react-emotion'
import { useTranslation } from 'react-i18next'
import Text from 'common/components/Text'
import { EDITOR, FILTERS } from '../../../constants'
import { connect } from 'react-redux'
import {
  sidebarSectionSelector,
  sidebarFilterSelector,
  sidebarFoldersSelector
} from '../../../store/selectors/sidebarSelectors'
import { userSelector } from '../../../store/selectors/baseSelectors'

const SidebarEmptyContainer = connect(state => ({
  folders: sidebarFoldersSelector(state),
  section: sidebarSectionSelector(state),
  filtered: FILTERS.includes(sidebarFilterSelector(state)),
  anon: userSelector(state).isAnonymous
}))

export const SidebarEmpty = styled(
  ({ className, section, filtered, folders, anon }) => {
    let message = 'sidebar.empty.'
    if (anon) message += 'anon.'

    // in a folder
    if (folders && folders.length) {
      // check for write access
      if (!anon && folders[folders.length - 1].accessLevel < EDITOR)
        message += 'readOnly.'
      message += 'emptyFolder'
    } else if (filtered) {
      message += 'filtered'
    } else {
      message += 'empty'
    }

    const { t } = useTranslation()
    return (
      <div className={className}>
        <Text grey>{t(message, {section})}</Text>
      </div>
    )
  }
)({
  label: 'SidebarEmpty',
  padding: '10%',
  height: '100%',
  textAlign: 'center',
  lineHeight: '18px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

export default SidebarEmptyContainer(SidebarEmpty)
